{
	"dismissScheduledMaintenanceNotification": "Dismiss scheduled maintenance notification",
	"upcomingScheduledMaintenance": "Upcoming scheduled maintenance",
	"viewLatestUpdates": "View latest updates"
}
